import { render } from "./QualiyAttrReq.vue?vue&type=template&id=58ef1554&scoped=true"
import script from "./QualiyAttrReq.vue?vue&type=script&lang=js"
export * from "./QualiyAttrReq.vue?vue&type=script&lang=js"

import "./QualiyAttrReq.vue?vue&type=style&index=0&id=58ef1554&lang=scss&scoped=true"

import exportComponent from "/Applications/CODE/mickwebsite/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ef1554"]])

export default __exports__